import { render, staticRenderFns } from "./CarStatusDropdown.vue?vue&type=template&id=161d98b8&scoped=true&"
import script from "./CarStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./CarStatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d98b8",
  null
  
)

export default component.exports